import {IPropertyDetail} from "../types/IPropertyDetail";
import {PropertyDisplayType} from "../types/PropertyDisplayType";

export const isPropertyArchived = (
    property: Pick<IPropertyDetail, "for_sale"> & {configuration: Pick<IPropertyDetail["configuration"], "display_type">}
): boolean => {
    const isPublished = property.configuration.display_type === PropertyDisplayType.PUBLISHED;
    return !property.for_sale || !isPublished;
};
import {IPropertyDetail} from "../types/IPropertyDetail";
import {PropertyDisplayType} from "../types/PropertyDisplayType";

export const isPropertyArchived = (
    property: Pick<IPropertyDetail, "for_sale"> & {configuration: Pick<IPropertyDetail["configuration"], "display_type">}
): boolean => {
    const isPublished = property.configuration.display_type === PropertyDisplayType.PUBLISHED;
    return !property.for_sale || !isPublished;
};
